import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const ClockIcon: IconComponent = ({ className, colorCode = 'white', width = 13, height = 15 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 13 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.2363 4.70125L11.422 3.51562"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.1875 3.28125L11.6562 3.75"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.5 3.28125V0.46875"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.90625 0.46875H5.09375"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.5 14.5312C9.6066 14.5312 12.125 12.0129 12.125 8.90625C12.125 5.79965 9.6066 3.28125 6.5 3.28125C3.3934 3.28125 0.875 5.79965 0.875 8.90625C0.875 12.0129 3.3934 14.5312 6.5 14.5312Z"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.5 5.15625C6.37056 5.15625 6.26562 5.26118 6.26562 5.39062C6.26562 5.52007 6.37056 5.625 6.5 5.625C6.62944 5.625 6.73438 5.52007 6.73438 5.39062C6.73438 5.26118 6.62944 5.15625 6.5 5.15625"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.5 12.1875C6.37056 12.1875 6.26562 12.2924 6.26562 12.4219C6.26562 12.5513 6.37056 12.6562 6.5 12.6562C6.62944 12.6562 6.73438 12.5513 6.73438 12.4219C6.73438 12.2924 6.62944 12.1875 6.5 12.1875V12.1875"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.98438 8.67188C2.85493 8.67188 2.75 8.77681 2.75 8.90625C2.75 9.03569 2.85493 9.14062 2.98438 9.14062C3.11382 9.14062 3.21875 9.03569 3.21875 8.90625C3.21875 8.77681 3.11382 8.67188 2.98438 8.67188V8.67188"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0156 8.67188C9.88618 8.67188 9.78125 8.77681 9.78125 8.90625C9.78125 9.03569 9.88618 9.14062 10.0156 9.14062C10.1451 9.14062 10.25 9.03569 10.25 8.90625C10.25 8.77681 10.1451 8.67188 10.0156 8.67188V8.67188"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.0141 6.1875C3.91925 6.18733 3.83365 6.24434 3.79725 6.33192C3.76085 6.41951 3.78082 6.52039 3.84785 6.5875C3.93932 6.67915 4.08777 6.67929 4.17941 6.58781C4.27106 6.49634 4.27119 6.3479 4.17972 6.25625C4.13589 6.21217 4.07626 6.18742 4.0141 6.1875V6.1875"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.98613 11.1582C8.92395 11.1581 8.86429 11.1828 8.8205 11.227C8.74148 11.3061 8.72936 11.43 8.79155 11.5229C8.85373 11.6159 8.97291 11.6519 9.07619 11.609C9.17946 11.5662 9.23807 11.4563 9.21617 11.3467C9.19426 11.237 9.09795 11.1581 8.98613 11.1582V11.1582"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.0141 11.1582C3.91925 11.158 3.83365 11.215 3.79725 11.3026C3.76085 11.3902 3.78082 11.4911 3.84785 11.5582C3.90702 11.6175 3.99332 11.6407 4.07425 11.6191C4.15518 11.5975 4.21843 11.5344 4.24019 11.4535C4.26194 11.3726 4.23889 11.2862 4.17972 11.227C4.13589 11.1829 4.07626 11.1581 4.0141 11.1582V11.1582"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.15227 6.25479C9.10824 6.21061 9.04839 6.18586 8.98602 6.18604V6.18604C8.92384 6.18588 8.86418 6.21064 8.82039 6.25479C8.72903 6.34638 8.72916 6.49467 8.82067 6.5861C8.91218 6.67754 9.06047 6.67754 9.15199 6.5861C9.2435 6.49467 9.24362 6.34638 9.15227 6.25479"
                stroke={color}
                strokeWidth="0.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
